const HTTP_STATUS_PATTERN = /\((\d{3})\)$/

export const isTransientGatewayError = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return true
  }

  const match = error.message.match(HTTP_STATUS_PATTERN)
  if (!match?.[1]) {
    return true
  }

  const status = Number(match[1])
  return status === 408 || status === 429 || status >= 500
}
